/**
 * One or two letters for the account chip.
 *
 * Never the whole address: an app bar is on screen in public, and someone's
 * email should not be readable over their shoulder at a festival.
 */
export function initialsFor(identity: string): string {
  const name = identity.split('@')[0] ?? identity;
  const parts = name.split(/[.\-_\s]+/).filter(Boolean);
  return ((parts[0]?.[0] ?? '?') + (parts[1]?.[0] ?? '')).toUpperCase();
}
